import { useEffect, useState } from 'preact/hooks';

type T = { id: number; text: string; kind: 'ok' | 'error' };
let push: ((t: T) => void) | null = null;
let n = 0;

export function toast(text: string, kind: 'ok' | 'error' = 'ok') { push?.({ id: ++n, text, kind }); }

export function Toasts() {
  const [items, setItems] = useState<T[]>([]);
  useEffect(() => {
    push = t => {
      setItems(prev => [...prev.slice(-2), t]);
      setTimeout(() => setItems(prev => prev.filter(x => x.id !== t.id)), t.kind === 'error' ? 6000 : 2800);
    };
    return () => { push = null; };
  }, []);
  return (
    <div class="fixed top-16 inset-x-0 z-[60] flex flex-col items-center gap-2 px-4 pointer-events-none" aria-live="polite">
      {items.map(t => (
        <div key={t.id} class={`pointer-events-auto max-w-md rounded-xl px-4 py-2.5 text-sm font-medium shadow-lg ${t.kind === 'error' ? 'bg-red-700 text-white' : 'bg-ink-900 text-white'}`}>{t.text}</div>
      ))}
    </div>
  );
}
